import React, { useEffect } from 'react';
import LocationDetails from '../../data-containers/location-details';
import LoadingSpinner from '../atoms/loading-spinner';
import ErrorWithTooltip from '../atoms/error-with-tooltip';
import ConnectivityIndicator from 'shared/dist/components/ui/connectivity-indicator';

export default function HubConnectivityStatus({id, installation}){
  const { hub_connectivity, hub_connectivity_fetch_status, hub } = installation || {};
  const { loading, error } = hub_connectivity_fetch_status || {};
  const { fetchHubConnectivity } = LocationDetails.useContainer();

  useEffect(
    () => {
      if(!hub_connectivity){
        // fetchHubConnectivity(id, hub);
      }
    },
    [hub, hub_connectivity]
  );

  return <div className="hub-connectivity-status">
    { error && <ErrorWithTooltip className="installation-error" error={error} /> }
    { loading && <LoadingSpinner className="inline tiny connectivity-loader" /> }
    { hub_connectivity && <ConnectivityIndicator connectivity={hub_connectivity} /> }
  </div>;
}